import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { ButtonGroup, Button, Form, FormGroup, Input, FormHelp } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import storage from '../../../../util/storage';

import { checkEmail, getUserPreference } from '../../UserActions';
import { setRedirect } from '../../../App/AppActions';
import { getLanguagePath } from '../../../Intl/IntlActions';
import { displayErrors } from '../../../Error/ErrorActions';

import User from '../../User';
import UserForgotPassword from './UserForgotPassword';
import UserNewPassword from './UserNewPassword';

class UserLoginForm extends User {
    constructor(props) {
        super(props);

        Object.assign(this.state, {
            step: 'email',
            displayFirstLoginHelp: false,
            displayForgotPasswordForm: !!props.code,
            isOnLogin: false,
            email: props.email || '',
            password: props.password || '',
            code: props.code || '',
        });

        this.handleCheckEmail = this.handleCheckEmail.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        if(this.props.location && this.props.location.query && this.props.location.query.access_token) {
            this.handleLoginWithToken(this.props.location.query.access_token);
        } else if(this.props.email && this.props.password) {
            this.handleLoginComponent(new Event('autoLogin'));
        } else if(!this.state.email && storage && storage.getItem('userEmail')) {
            this.goToPasswordStep();
        }
    }

    goToPasswordStep() {
        this.setState({
            email: storage.getItem('userEmail'),
            step: 'password',
        });
    }

    handleCheckEmail(event) {
        if(checkEmail(this.state.email)) {
            this.checkEmailExists().then(result => {
                if(result && result.ok) {
                    this.setState({ step: result.isOldUser ? 'verification' : 'password' });
                    storage && storage.setItem('userEmail', this.state.email);
                } else {
                    displayErrors('error', this.props.intl.formatMessage({ id: 'userAccountExistError', defaultMessage: 'Your email address is not associated to an account!' }));
                }
            });
        } else {
            displayErrors('warning', this.props.intl.formatMessage({ id: 'userEmailError', defaultMessage: 'Your email address is incorrect!' }));
        }
    }

    handleLoginComponent(event) {
        event.preventDefault();
        if(this.state.email && this.state.password) {
            this.setState({ isOnLogin: true });
            this.handleLogin().then(user => {
                this.setState({
                    isOnLogin: false,
                });
                if(!user) {
                    displayErrors('error', this.props.intl.formatMessage({
                        id: 'userLoginError',
                        defaultMessage: 'Wrong credentials! Please retry...',
                    }));
                } else if(!this.state.newPasswordRequired) {
                    this.props.dispatch(setRedirect(this.props.appRedirect || this.props.redirect || getLanguagePath('/', getUserPreference(user, 'language'))));
                }
            });
        } else {
            const errorFields = [];
            if(!this.state.email) {
                errorFields.push('email');
            }
            if(!this.state.password) {
                errorFields.push('password');
            }
            this.setState({ errorFields });
        }
    }

    handleForgotPassword() {
        this.setState({ displayForgotPasswordForm: true });
    }

    handleSubmit(event) {
        event && event.preventDefault();
        switch(this.state.step) {
            case 'email':
                this.handleCheckEmail(event);
                break;

            case 'password':
            default:
                this.handleLoginComponent(event);
                break;
        }
    }

    render() {
        return (
            <div>
                {
                    this.state.displayForgotPasswordForm
                        ? <UserForgotPassword email={this.state.email} code={this.state.code} closeForm={() => this.setState({ displayForgotPasswordForm: false })} redirect={this.props.redirect} />
                        : (
                            <Fragment>
                                {
                                    this.state.newPasswordRequired
                                        ? <UserNewPassword user={this.state.user} userAttributes={this.state.userAttributes} redirect={this.props.redirect} />
                                        : (
                                            <Form onSubmit={this.handleSubmit}>
                                                {
                                                    this.state.step !== 'verification'
                                                        ? (
                                                            <FormGroup className="text-center">
                                                                <FontAwesome name="info-circle" /> <FormattedMessage id="userLoginIntro" defaultMessage="Please login to access to your dashboard." />
                                                            </FormGroup>
                                                        )
                                                        : null
                                                }

                                                {
                                                    this.state.step === 'email'
                                                        ? (
                                                            <FormGroup className={this.hasErrorField('email') ? 'has-danger text-danger' : ''}>
                                                                <Input type="text" name="email" id="emailField" className={`form-control-user ${this.hasErrorField('email') ? 'is-invalid form-control-danger' : ''}`} onChange={this.handleChange} placeholder={this.props.intl.messages.userEmailFillInfo} value={this.state.email} autoFocus />
                                                            </FormGroup>
                                                        )
                                                        : null
                                                }

                                                {
                                                    this.state.step === 'password'
                                                        ? (
                                                            <div>
                                                                <p className="text-center">
                                                                    <FormattedMessage id="userLoginEmailSelected" defaultMessage="Login with email: {email}" values={{ email: this.state.email }} /><br />
                                                                    <Button color="link" size="sm" className="p-0" onClick={() => this.setState({ step: 'email' })}>
                                                                        <FontAwesome name="chevron-left" /> <FormattedMessage id="userEmailSwitch" defaultMessage="Switch email address" />
                                                                    </Button>
                                                                </p>
                                                                <FormGroup>
                                                                    <Input type={this.state.displayPassword ? 'text' : 'password'} name="password" id="passwordField" className={`${this.hasErrorField('password') ? 'is-invalid form-control-danger' : ''}`} onChange={this.handleChange} placeholder={this.props.intl.messages.userPassword} value={this.state.password} autoFocus />
                                                                    <div className="text-right">
                                                                        <a href="#" onClick={event => { event.preventDefault(); this.setState({ displayPassword: !this.state.displayPassword }); }}><FontAwesome name={this.state.displayPassword ? 'eye-slash' : 'eye'} /> {this.state.displayPassword ? <FormattedMessage id="userPasswordHideButton" defaultMessage="Hide password" /> : <FormattedMessage id="userPasswordDisplayButton" defaultMessage="Display password" />}</a>
                                                                    </div>
                                                                </FormGroup>
                                                            </div>
                                                        )
                                                        : null
                                                }

                                                {
                                                    this.state.step === 'verification'
                                                        ? (
                                                            <div className="text-center">
                                                                <p>
                                                                    <FontAwesome name="info-circle" /> <FormattedMessage id="userRecoverFromOldAppText" defaultMessage="You've been migrated from old app! Check your mailbox to recover your password and activate your new account!" />
                                                                </p>
                                                                <ButtonGroup size="sm" className="my-2">
                                                                    <Button color="secondary" outline onClick={() => this.setState({ step: 'email' })}>
                                                                        <FontAwesome name="chevron-left" /> <FormattedMessage id="back" defaultMessage="Back" />
                                                                    </Button>
                                                                    <Button color="info" onClick={() => this.setState({ step: 'password' })}>
                                                                        <FontAwesome name="check" /> <FormattedMessage id="userRecoverFromOldAppCheckButton" defaultMessage="I well received my recover password email" />
                                                                    </Button>
                                                                </ButtonGroup>
                                                            </div>
                                                        )
                                                        : null
                                                }

                                                <FormGroup>
                                                    <ButtonGroup className="btn-block">
                                                        {
                                                            this.props.closeForm
                                                                ? (
                                                                    <Button color="secondary" onClick={event => this.props.closeForm()}>
                                                                        <FontAwesome name="chevron-left" /> <span className="d-none d-sm-inline"><FormattedMessage id="back" defaultMessage="Back" /></span>
                                                                    </Button>
                                                                )
                                                                : null
                                                        }
                                                        {
                                                            this.state.step !== 'verification'
                                                                ? (
                                                                    <Button color="secondary" className="btn-user" onClick={() => this.handleForgotPassword()}>
                                                                        <FontAwesome name="unlock" /> <span className="d-none d-sm-inline"><FormattedMessage id="userForgotPassword" defaultMessage="Forgot password?" /></span>
                                                                    </Button>
                                                                )
                                                                : null
                                                        }
                                                        {
                                                            this.state.step === 'email'
                                                                ? (
                                                                    <Button color="warning" disabled={!this.state.email} onClick={this.handleCheckEmail}>
                                                                        <FormattedMessage id="next" defaultMessage="Next" /> <FontAwesome name="chevron-right" />
                                                                    </Button>
                                                                )
                                                                : null
                                                        }
                                                        {
                                                            this.state.step === 'password'
                                                                ? (
                                                                    <Button color="warning" disabled={!this.state.email || !this.state.password || this.state.isOnLogin}>
                                                                        <FontAwesome name={this.state.isOnLogin ? 'spinner' : 'power-off'} spin={this.state.isOnLogin} /> <FormattedMessage id="userLoginAction" defaultMessage="Login" />
                                                                    </Button>
                                                                )
                                                                : null
                                                        }
                                                    </ButtonGroup>
                                                </FormGroup>

                                                {
                                                    !this.props.hideRegisterButton && (
                                                        <FormGroup>
                                                            <hr />
                                                            <Button color="warning" size="lg" block outline tag={Link} to="/user/register">
                                                                <FontAwesome name="user-plus" /> <FormattedMessage id="userRegister" defaultMessage="Create my account" />
                                                            </Button>
                                                        </FormGroup>
                                                    )
                                                }
                                            </Form>
                                        )
                                }
                            </Fragment>
                        )
                }
            </div>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        intl: store.intl,
        appRedirect: store.app.redirect,
    };
}

UserLoginForm.defaultProps = {
    appRedirect: null,
    email: '',
    password: '',
    code: '',
    hideRegisterButton: false,
};

UserLoginForm.propTypes = {
    location: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
    appRedirect: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,
    code: PropTypes.string,
    hideRegisterButton: PropTypes.bool,
};

export default connect(mapStateToProps)(withRouter(injectIntl(UserLoginForm)));
